import Carousel from 'react-bootstrap/Carousel';
import ImageSingle from '@/components/srp/CardComponents/ImageSingle';
import '/src/components/pdp/style/pdp.css'
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Gallery, Item } from "react-photoswipe-gallery";
import ImageGallery from "react-image-gallery";
// import stylesheet if you're not already using CSS @import
import "react-image-gallery/styles/css/image-gallery.css";
import PropertyTags from './PropertyTags';
import { trackButtonClick } from '@/utils/analytics';

export default function PDPGallery(props) {
  const containerRef = useRef(null);
  const [previousIndex, setPreviousIndex] = useState(0);
  const [isArrowNavigation, setIsArrowNavigation] = useState(false);


  const scrollThumbnails = (direction) => {
    const thumbnailsWrapper = containerRef.current?.querySelector(
      ".image-gallery-thumbnails"
    );

    if (thumbnailsWrapper) {
      const scrollAmount = 200;
      thumbnailsWrapper.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }

    trackButtonClick({
      eventName: "gallery_thumbnail_arrow_click",
      eventCategory: "NEW-PDP",
      eventSource: "Thumbnail Navigation",
      eventParams: { direction: direction === "left" ? "left" : "right" },
    });

    props?.modal &&
      trackButtonClick({
        pageName: "lightbox_gallery_nav",
        eventCategory: "NEW-PDP",
        eventParams: { direction: direction === "left" ? "prev" : "next" },
    });
  };

  const handleSlide = (currentIndex) => {
    const thumbnailsWrapper = containerRef.current?.querySelector(
      ".image-gallery-thumbnails"
    );

    if (thumbnailsWrapper) {
      const thumbnails = thumbnailsWrapper.querySelectorAll('.image-gallery-thumbnail');
      const activeThumbnail = thumbnails[currentIndex];

      if (activeThumbnail) {
        activeThumbnail.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }

    // Only track arrow navigation, not thumbnail clicks
    if (isArrowNavigation) {
      const direction = currentIndex > previousIndex ? "Right Arrow" : "Left Arrow";

      trackButtonClick({
        eventName: "gallery_arrow_click",
        eventCategory: "NEW-PDP",
        eventParams: { direction: direction == "Right Arrow" ? "right" : "left" },
      });

      if (props?.modal) {
        const lightboxAction = direction === "Right Arrow" ? "next" : "prev";
        trackButtonClick({
          eventName: "lightbox_gallery_navigation_click",
          eventParams: { lightbox_action: lightboxAction },
          eventCategory: "NEW-PDP",
        });
      }

      setIsArrowNavigation(false); // Reset flag
    } else {
      // This is a thumbnail click
      trackButtonClick({
        eventName: "gallery_lightbox_thumb_click",
        eventCategory: "NEW-PDP",
      });
    }

    setPreviousIndex(currentIndex);
  };

  const getImages = () =>
    props.images.map((item) => ({
      thumbnail: item.thumbnailURL,
      original: item.largeURL,
      thumbnailClass: "image-thumbnail-custom",
  }));

  useEffect(() => {
    const handleNavClick = (e) => {
      if (e.target.closest('.image-gallery-left-nav, .image-gallery-right-nav')) {
        setIsArrowNavigation(true);
      }
    };

    const galleryContainer = containerRef.current;
    if (galleryContainer) {
      galleryContainer.addEventListener('click', handleNavClick);
      return () => galleryContainer.removeEventListener('click', handleNavClick);
    }
  }, []);


  return (
    <div
      ref={containerRef}
      className="pdp-gallery custom-gallery-container"
      id={props.galleryID}
      style={{
        width: "100%",
        minHeight: 500,
        maxHeight: 800,
        position: "relative",
      }}
    >
      {props?.images?.length > 0 ? (
        <>
          <PropertyTags cmsKeyInfographic={props?.cmsKeyInfographic} />
          <ImageGallery
            items={getImages()}
            showIndex={true}
            showFullscreenButton={false}
            showPlayButton={false}
            showThumbnails={true}
            thumbnailPosition="bottom"
            slideOnThumbnailOver={false}
            disableThumbnailScroll={true}
            showThumbnailsNav={false}
            onSlide={handleSlide}
          />

          {props?.images?.length > 3 && (
            <>
              <button
                onClick={() => scrollThumbnails("left")}
                className="thumbnail-nav left"
              >
                ‹
              </button>
              <button
                onClick={() => scrollThumbnails("right")}
                className="thumbnail-nav right"
              >
                ›
              </button>
            </>
          )}

          <style jsx>{`
            .thumbnail-nav {
              position: absolute;
              bottom: 10px;
              z-index: 10;
              background: grey;
              opacity: 0.5;
              color: white;
              border: none;
              font-size: 20px;
              width: 35px;
              height: 35px;
              cursor: pointer;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .thumbnail-nav:hover {
              background: rgba(0, 0, 0, 0.9);
            }
            .thumbnail-nav.left {
              left: 10px;
            }
            .thumbnail-nav.right {
              right: 61px;
            }
          `}</style>
        </>
      ) : (
        <>
          <PropertyTags cmsKeyInfographic={props?.cmsKeyInfographic} />
          <ImageSingle
            imageUrl={props?.images}
            className="pdp-gallery custom-gallery-container"
            style={{
              backgroundSize: "cover",
              width: "50%",
              height: 450,
              borderRadius: 10,
            }}
            isPDP={true}
          />
        </>
      )}
    </div>
  );
}